<template>
  <b-card
    v-if="mySynthesisSheetsData && mySynthesisSheetsData.ficheMission"
    class="mb-3 shadow"
  >
    <h3 slot="header" class="h6 m-0 text-muted">
      {{ $t("my-doc-synthesis-sheet-block-title") }}
    </h3>
    <b-media>
      <svgicon
        slot="aside"
        icon="invoice"
        width="48"
        height="48"
        color="#ddd"
      ></svgicon>
      <div class="row">
        <div class="col-sm-6 col-lg-7">
          <p class="h5 mb-1">
            <span class="text-muted">
              {{ $t("my-doc-sythesis-last-sheet-title") }}
            </span>
          </p>
        </div>
        <div class="col-sm-6 col-lg-5">
          <b-btn
            variant="primary"
            size="sm"
            block
            @click="
              checkFileExistanceAndDownload(
                mySynthesisSheetsData.ficheMission,
                fileName,
                $event
              )
            "
          >
            <svgicon icon="download" class="mr-1"></svgicon>
            {{ $t("documents-download-btn") }}
          </b-btn>
        </div>
      </div>
    </b-media>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DownloadPdf from "../../Mixins/downloadPdf.js";

export default {
  mixins: [DownloadPdf],
  created() {
    this.loadedMySynthesisSheets();
  },
  computed: {
    ...mapGetters("document", ["mySynthesisSheetsData"]),
    fileName() {
      if (
        !this.mySynthesisSheetsData ||
        !this.mySynthesisSheetsData.ficheMission
      )
        return "";
      const fullPath = this.mySynthesisSheetsData.ficheMission;
      const parts = fullPath.split(/[/\\]/);
      return parts[parts.length - 1];
    }
  },
  methods: {
    ...mapActions("document", ["loadedMySynthesisSheets"])
  }
};
</script>
